import { H4, HorizontalRule } from '@snsw/react-component-library';
import { PlantDesignDrawingAndTechDetailsPage } from 'plantDesign/constants/plantDesignDrawingAndTechDetailsPage';
import { DrawingListView } from 'plantDesign/pages/drawingsAndTechDetails/components/DrawingListView';
import { TechStandardListView } from 'plantDesign/pages/drawingsAndTechDetails/components/TechStandardListView';
import React from 'react';
import { capitalizeFirstLetter } from 'shared/utils/Helpers';
import styles from '../PlantDesignReview.module.scss';

export const DrawingsAndTechnicalStandardsReview = (props) => {
  const { drawingsAndTechStandards } = props;
  const { drawings, techStandards, engineeringPrinciples } = drawingsAndTechStandards;

  return (
    <>
      {drawings && (
        <>
          <H4>Drawings</H4>
          <DrawingListView
            id="drawingReview"
            items={drawingsAndTechStandards.drawings}
            showHeading={false}
            showEditRemove={false}
            showAddButton={false}
          />
        </>
      )}

      {techStandards && (
        <>
          <H4>Technical standards</H4>
          <TechStandardListView
            dListView
            id="techStandardsReview"
            items={drawingsAndTechStandards.techStandards}
            showHeading={false}
            showEditRemove={false}
            showAddButton={false}
          />
        </>
      )}

      {engineeringPrinciples && (
        <>
          <div className={styles.listViewDetailsValue}>
            {PlantDesignDrawingAndTechDetailsPage.engineeringPrinciples.designComplianceLabel}
          </div>
          <div>{capitalizeFirstLetter(engineeringPrinciples.complyWithTechStandard)}</div>

          {/* TODO: Use ListView Component */}
          {!!engineeringPrinciples.engineeringPrincipleFile?.length && (
            <>
              <H4 className={styles.summaryLabel}>Engineering Principles</H4>
              <HorizontalRule className={styles.horizontalRule} />
              <div className={styles.listViewDetailsValue}>
                {PlantDesignDrawingAndTechDetailsPage.engineeringPrinciples.uploadedFileLabel}
              </div>

              {engineeringPrinciples.engineeringPrincipleFile.map((file) => (
                <div key={file.id}>{file.name}</div>
              ))}
            </>
          )}
          <br></br>
        </>
      )}
    </>
  );
};
